import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import GardenShell from './GardenShell';
import ZonesHomeScreen from './screens/ZonesHomeScreen';
import ZoneDetailScreen from './screens/ZoneDetailScreen';
import PlantsListScreen from './screens/PlantsListScreen';
import PlantDetailScreen from './screens/PlantDetailScreen';
import PlantFormScreen from './screens/PlantFormScreen';
import AddPlantChoiceScreen from './screens/AddPlantChoiceScreen';
import IdentifyPlantFlowScreen from './screens/IdentifyPlantFlowScreen';
import ScanPlantTagScreen from './screens/ScanPlantTagScreen';
import ScanConfirmScreen from './screens/ScanConfirmScreen';
import TasksScreen from './screens/TasksScreen';
import JournalScreen from './screens/JournalScreen';
import JournalEntryFormScreen from './screens/JournalEntryFormScreen';
import AIHelpScreen from './screens/AIHelpScreen';
import SettingsScreen from './screens/SettingsScreen';

export default function GardenApp() {
  return (
    <Routes>
      <Route element={<GardenShell />}>
        <Route index element={<ZonesHomeScreen />} />
        <Route path="zones/:zoneId" element={<ZoneDetailScreen />} />
        <Route path="plants" element={<PlantsListScreen />} />
        <Route path="plants/add" element={<AddPlantChoiceScreen />} />
        <Route path="plants/identify" element={<IdentifyPlantFlowScreen />} />
        <Route path="plants/scan" element={<ScanPlantTagScreen />} />
        <Route path="plants/scan/confirm" element={<ScanConfirmScreen />} />
        <Route path="plants/new" element={<PlantFormScreen />} />
        <Route path="plants/:plantId" element={<PlantDetailScreen />} />
        <Route path="plants/:plantId/edit" element={<PlantFormScreen />} />
        <Route path="tasks" element={<TasksScreen />} />
        <Route path="journal" element={<JournalScreen />} />
        <Route path="journal/new" element={<JournalEntryFormScreen />} />
        <Route path="journal/:entryId" element={<JournalEntryFormScreen />} />
        <Route path="ai" element={<AIHelpScreen />} />
        <Route path="settings" element={<SettingsScreen />} />
        <Route path="*" element={<Navigate to="/garden" replace />} />
      </Route>
    </Routes>
  );
}
